module.exports = __webpack_public_path__ + "img/agpz-train-default.aaaf93bd.svg";